// web-ai-disclaimer: שורה אחת קבועה בתחתית כל מסך (גם בכניסה, גם מעל הגדלה). הגובה שמור ב---ab-foot (index.css):
// כל מה שנצמד לתחתית (סרגל תחתון, שדה הכתיבה, sheet, הגדלה) נגמר מעליה, כך שהיא לא מסתירה תוכן.
import { T } from '../lib/strings.ts';

export function Disclaimer() {
  return (
    <footer className="ab-disclaimer" data-testid="disclaimer">
      <p>{T.disclaimer}</p>
    </footer>
  );
}
